import { CanMatchFn, Route, Router, UrlSegment } from "@angular/router";
import { LocalStorageType } from "../types/localStorage.type";
import { inject } from "@angular/core";
import { pathExistOnMenu } from "../utils/pathExistOnMenu.util";

export const RouteGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
    const storageMenu = localStorage.getItem(LocalStorageType.Menu);
    const menu = JSON.parse(storageMenu!);
    const router = inject(Router);

    if(pathExistOnMenu(menu, route.path!))
        return true;

    router.navigate(['/blocked']);
    return false;
};